<script setup lang="ts">
import { type PropType, computed } from 'vue'
import { checkIsSeoEnhancement } from '@/lib/checkService'
import BaseBreadcrumb from '@/components/ui/BaseBreadcrumb.vue'
import { type IBreadcrumbItem } from '@/types/BreadCrumb'
import Skeleton from '@/components/Skeleton.vue'

const isSeoEnhancement = checkIsSeoEnhancement()
const props = defineProps({
	breadcrumbs: {
		type: Array as PropType<IBreadcrumbItem[]>,
		required: true,
	},
	isNeedSkeleton: {
		type: Boolean,
		default: false,
	},
	isLoading: {
		type: Boolean,
		default: true,
	},
	skeletonWidth: {
		type: Number,
		default: 240,
	},
})

const isAllItemsEmpty = computed(() => {
	return props.breadcrumbs.every(breadcrumb => !breadcrumb.displayName)
})
</script>

<template>
	<div v-if="isSeoEnhancement && !isAllItemsEmpty" class="bs-container py-20px">
		<div class="col-span-12">
			<Skeleton
				v-if="isNeedSkeleton && isLoading"
				:class="`h-[24px] w-[${skeletonWidth}px]`"
			></Skeleton>
			<BaseBreadcrumb v-else :breadcrumbs="breadcrumbs" isLastItemSelf />
		</div>
	</div>
</template>
